var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsNotificationActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.447,
    height: 20,
    viewBox: "0 0 18.447 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_notification",
    d: "M14.868,4.009a7.824,7.824,0,0,0-7.322,7.879v3.727L6.187,18.35l-.007.015A1.818,1.818,0,0,0,7.8,20.924h4.358a3.077,3.077,0,0,0,6.154,0h4.357A1.818,1.818,0,0,0,24.3,18.365l-.007-.015-1.359-2.734V11.693A7.706,7.706,0,0,0,14.868,4.009Zm.072,1.536a6.141,6.141,0,0,1,6.452,6.147v4.1a.769.769,0,0,0,.08.343L22.9,19.021a.238.238,0,0,1-.232.365H7.8a.238.238,0,0,1-.231-.365h0L9,16.138a.769.769,0,0,0,.08-.343V11.888A6.279,6.279,0,0,1,14.94,5.546ZM13.7,20.924h3.077a1.538,1.538,0,0,1-3.077,0Z",
    transform: "translate(-6.015 -4.001)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNotificationActive);
export default __webpack_public_path__ + "static/media/iconsNotificationActive.87900911caef5ae1d4ca4db2a7143e85.svg";
export { ForwardRef as ReactComponent };